import { FEMALE, genderMapping, MALE, UNKNOWN } from "./gender";
import { EXECUTE, INFORMATIONAL, SKIP } from "./serviceMode";

export const poaValues = [
    { value: '', text: 'Select One...' },
    { value: 'Y', text: 'Y' },
    { value: 'N', text: 'N' },
    { value: 'W', text: 'W' },
    { value: 'U', text: 'U' },
    { value: 'One', text: '1' },
    { value: 'Blank', text: 'Blank' }
];

export const genderValues = [
    { value: '', text: 'Select One...' },
    { value: MALE, text: genderMapping[MALE] },
    { value: FEMALE, text: genderMapping[FEMALE] },
    { value: UNKNOWN, text: genderMapping[UNKNOWN] }
]

export const serviceModeValues = [
    { value: EXECUTE, text: 'Execute (Apply to Pricing)' },
    { value: INFORMATIONAL, text: 'Execute (Informational)' },
    { value: SKIP, text: 'Skip' }
]